import { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { ContentApi } from "../../../shared/api/contentApi.js";
import {
    UiDialogRoot,
    UiDialogContent,
    UiDialogTitle,
    UiDialogDescription,
    UiDialogClose,
    UiDialogHeader,
    UiDialogBody,
    UiDialogFooter,
} from "../../../components/ui/ant/Dialog.jsx";
import {
  Button,
  Form,
  Input,
  Select,
  Switch,
  App
} from 'antd';
import { DialogRow } from "./DialogRow.jsx";


export default function VersionEditDialog({ open, project, version, onClose, onSaved }) {
    const [systemName, setSystemName] = useState("");
    const [name, setName] = useState("");
    const [comment, setComment] = useState("");

    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!open || !version) return;
        setSystemName(version.systemName || "");
        setName(version.name || "");
        setComment(version.comment || "");
        setError("");
    }, [open, version]);

    const canSubmit = useMemo(
        () => !!version?.id && systemName.trim() && name.trim() && !saving,
        [version?.id, systemName, name, saving],
    );

    const onSubmit = async (e) => {
        e?.preventDefault?.();
        if (!canSubmit) return;

        setSaving(true);
        setError("");

        try {
            let current = version;

            const updated = await ContentApi.patchVersion(project.id, version.id, {
                name: name.trim(),
                comment: comment.trim() || null,
            });

            onSaved?.(updated || current);
            onClose?.();
        } catch (e) {
            setError(e?.message || "Не удалось сохранить изменения");
        } finally {
            setSaving(false);
        }
    };

    if (!open || !version) return null;

    return (
        <UiDialogRoot open={open} onOpenChange={(next) => !next && onClose?.()}>
            <UiDialogContent size="md">
                <UiDialogHeader>
                    <div>
                        <UiDialogTitle>Редактировать версию</UiDialogTitle>
                        <UiDialogDescription>ID: {version.id}</UiDialogDescription>
                    </div>
                    <UiDialogClose showIcon />
                </UiDialogHeader>

                <UiDialogBody>
                    {error && (
                        <div className="mb-4 rounded-xl border border-red-300 bg-red-50 text-red-700 p-3 text-sm">
                            {error}
                        </div>
                    )}

                    <Form className="space-y-4" onSubmit={onSubmit}>
                        <Form.Item  label="System Name *" name="systemName">
                            <Input
                                className="input w-full"
                                value={systemName}
                                placeholder="project_ingot"
                                disabled
                            />
                        </Form.Item>

                        <Form.Item label="Название *" name="name">
                            <Input
                                className="input w-full"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Project Ingot"
                                required
                            />
                        </Form.Item>

                        <Form.Item label="Комментарий" name="comment">
                            <Input.TextArea
                                className="input w-full"
                                rows={3}
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                placeholder="Комментарий для UI"
                            />
                        </Form.Item>

                        {/* <Form.Field name="parentVersionId">
                            <DialogRow label="Parent Version ID">
                                <Form.Control asChild>
                                    <input
                                        className="input"
                                        value={parentVersionId}
                                        onChange={(e) => setParentVersionId(e.target.value)}
                                        placeholder="Parent Version ID"
                                    />
                                </Form.Control>
                            </DialogRow>
                        </Form.Field> */}
                    </Form>
                </UiDialogBody>

                <UiDialogFooter>
                    <button type="button" className="btn btn-soft-accent" onClick={onSubmit} disabled={!canSubmit}>
                        {saving ? "Сохраняем..." : "Сохранить"}
                    </button>
                    <button type="button" className="btn btn-outline" onClick={onClose}>
                        Отмена
                    </button>
                </UiDialogFooter>
            </UiDialogContent>
        </UiDialogRoot>
    );
}

VersionEditDialog.propTypes = {
    open: PropTypes.bool,
    projectId: PropTypes.string,
    version: PropTypes.object,
    onClose: PropTypes.func,
    onSaved: PropTypes.func,
};
